export default {
    body: 'azo-sans-web, Helvetica, Arial, sans-serif',
    heading: 'azo-sans-web, Helvetica, Arial, sans-serif',
    mono: 'azo-sans-web, Helvetica, Arial, sans-serif'
};
